import { auth } from "../firebase";

export const API = process.env.REACT_APP_API_URL ?? "http://localhost:3001";

export async function apiFetch(
  path: string,
  init: RequestInit = {},
  options: { auth?: boolean } = {}
): Promise<Response> {
  const headers = new Headers(init.headers || undefined);

  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  if (options.auth !== false) {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("Authentification requise.");
    }

    const token = await user.getIdToken();
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(`${API}/api${path}`, {
    ...init,
    headers,
  });
}